<template>
    <div class="navWrapper">
        <div id="nav">
            <Accordion class="g1" v-model:value="reportsActiveIndex" @update:value="closeEmulsionsAndTanksAccordion">
                <AccordionPanel value="1">
                    <AccordionHeader>Raporty</AccordionHeader>
                    <AccordionContent>
                        <router-link to="/reports"
                                     @click="closeAccordions">
                            <i class="pi pi-book"></i>
                            <span>Raporty</span>
                        </router-link>
                        <router-link :to="haveInvestments ? '/report' : ''"
                                     :title="!haveInvestments ? missingInvestmentsMsg : ''"
                                     @click="closeAccordions">
                            <i class="pi pi-plus"></i>
                            <span>Raport</span>
                        </router-link>
                    </AccordionContent>
                </AccordionPanel>
            </Accordion>

            <Accordion class="g2" v-model:value="emulsionsActiveIndex" @update:value="closeReportsAndTanksAccordion">
                <AccordionPanel value="1">
                    <AccordionHeader>Materiały</AccordionHeader>
                    <AccordionContent>
                        <router-link to="/emulsions"
                                     @click="closeAccordions">
                            <i class="pi pi-book"></i>
                            <span>Materiały</span>
                        </router-link>
                        <router-link :to="haveTanks ? '/emulsion' : ''"
                                     :title="!haveTanks ? missingTanksMsg : ''"
                                     @click="closeAccordions">
                            <i class="pi pi-plus"></i>
                            <span>Materiał</span>
                        </router-link>
                    </AccordionContent>
                </AccordionPanel>
            </Accordion>

            <Accordion class="g4" v-model:value="tanksActiveIndex" @update:value="closeReportsAndEmulsionsAccordion">
                <AccordionPanel value="1">
                    <AccordionHeader>Zbiorniki</AccordionHeader>
                    <AccordionContent>
                        <router-link to="/tank-statement" @click="closeAccordions">
                            <i class="pi pi-file-pdf"></i>
                            <span>Zestawienie</span>
                        </router-link>
                    </AccordionContent>
                </AccordionPanel>
            </Accordion>

            <div class="logo"></div>
            <Button icon="pi pi-power-off" class="g3" label="Wyloguj" @click="signOut"/>
            <ConfirmDialog></ConfirmDialog>
        </div>
    </div>
</template>

<script>
import Button from 'primevue/button';
import ConfirmDialog from 'primevue/confirmdialog';
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionContent from 'primevue/accordioncontent';
import AccordionHeader from 'primevue/accordionheader';
import {ref, onMounted} from "vue";
import {EmulsionReportAddingStatus, ReportAddingStatus} from "../api";
import {useConfirm} from "primevue/useconfirm";
import {useRouter} from "vue-router";

export default {
    name: 'Header',
    components: {
        Button,
        ConfirmDialog,
        Accordion,
        AccordionPanel,
        AccordionContent,
        AccordionHeader
    },
    setup() {
        const reportsActiveIndex = ref(null);
        const emulsionsActiveIndex = ref(null);
        const tanksActiveIndex = ref(null);
        const confirm = useConfirm();
        const haveInvestments = ref(false);
        const haveTanks = ref(false)
        const router = useRouter();
        const missingInvestmentsMsg = ref('Nie masz w tej chwili przypisanych żadnych budów do których możesz dodać raport');
        const missingTanksMsg = ref('Nie masz w tej chwili przypisanych żadnych zbiorników do których możesz dodać raport');

        onMounted(() => {
            ReportAddingStatus().then((response) => {
                haveInvestments.value = response?.haveInvestments;
            });
            EmulsionReportAddingStatus().then((response) => {
                haveTanks.value = response?.haveTanks;
            });
        });

        const signOut = () => {
            confirm.require({
                message: 'Czy chcesz się wylogować?',
                header: 'Wylogowanie',
                icon: 'pi pi-power-off',
                accept: () => {
                    localStorage.removeItem('token');
                    router.push('/login')
                },
                reject: () => {
                }
            });
        };

        const closeAccordions = () => {
            reportsActiveIndex.value = null;
            emulsionsActiveIndex.value = null;
            tanksActiveIndex.value = null;
        }

        const closeEmulsionsAndTanksAccordion = () => {
            emulsionsActiveIndex.value = null;
            tanksActiveIndex.value = null;
        }

        const closeReportsAndTanksAccordion = () => {
            reportsActiveIndex.value = null;
            tanksActiveIndex.value = null;
        }

        const closeReportsAndEmulsionsAccordion = () => {
            reportsActiveIndex.value = null;
            emulsionsActiveIndex.value = null;
        }

        return {haveInvestments, haveTanks, missingInvestmentsMsg, missingTanksMsg, reportsActiveIndex, emulsionsActiveIndex, tanksActiveIndex, signOut, closeAccordions, closeEmulsionsAndTanksAccordion, closeReportsAndTanksAccordion, closeReportsAndEmulsionsAccordion}
    }
}
</script>

<style lang="scss">
@import "@core/scss";

$menuShadow: 0 5px 22px -5px rgba($color-graphite, 1);
$navButtonsHeight: 40px;

div.navWrapper {
    background: $color-whisper;

    #nav {
        display: grid;
        grid-row-gap: 10px;
        grid-template-areas: ". logo g3"
                             "g1 g2 g4";
        grid-template-columns: 1fr 1fr 1fr;

        margin: auto;
        padding: 15px 5px;

        @include respond-to(414plus) {
            padding: 15px;
        }

        @include respond-to(768plus) {
            grid-template-areas: "g1 g2 g4 logo g3";
            grid-template-columns: 1fr 1fr 1fr 2fr 3fr;
        }

        @include respond-to(1024plus) {
            grid-template-columns: 1fr 1fr 1fr 3fr 3fr;
        }

        & > div.p-accordion > div.p-accordionpanel {
            position: relative;

            & button.p-accordionheader {
                height: $navButtonsHeight;
                box-sizing: border-box;
                font-size: 0.875rem;
                --p-icon-size: 0.75rem;

                @include respond-to(568plus) {
                    font-size: 1rem;
                    --p-icon-size: 0.875rem;
                }
            }

            & div.p-accordioncontent {
                position: absolute;
                width: 100%;
                box-shadow: $menuShadow;
                top: 40px;

                & div.p-accordioncontent-content {
                    display: flex;
                    flex-direction: column;
                    padding: 0.125rem 0.625rem;

                    & > a {
                        display: flex;
                        justify-content: space-between;
                        margin: 1rem 0;
                        color: $color-graphite;
                        font-weight: normal;

                        & > span {
                            margin: 0 auto;
                            font-size: 0.875rem;

                            @include respond-to(568plus) {
                                font-size: 1rem;
                            }
                        }
                    }
                }
            }
        }

        & > .g1 {
            grid-area: g1;
            margin: auto;

            @include respond-to(768plus) {
                margin: auto auto auto 0;
            }
        }

        & > .g2 {
            grid-area: g2;
            margin: auto;

            @include respond-to(768plus) {
                margin: auto auto auto 0;
            }
        }

        & > .g4 {
            grid-area: g4;
            margin: auto;

            @include respond-to(768plus) {
                margin: auto auto auto 0;
            }
        }

        & > .g3 {
            grid-area: g3;
            margin: auto;

            @include respond-to(768plus) {
                margin: auto 0 auto auto;
            }
        }

        & > .logo {
            grid-area: logo;
            background-image: url(../../../core/assets/logo_100_25.svg);
            background-repeat: no-repeat;
            background-size: contain;
            margin: auto;
            width: 100px;
            height: 25px;
        }

        & > button {
            height: $navButtonsHeight;
            box-shadow: 0 3px 1px -2px rgba($color-black, 0.2),
                        0 2px 2px 0 rgba($color-black,0.14),
                        0 1px 5px 0 rgba($color-black,0.12);
            border-color: transparent;

            & > span {
                --p-icon-size: 0.75rem;

                @include respond-to(568plus) {
                    --p-icon-size: 0.875rem;
                }
            }
        }

        button {
            width: 110px;
            font-size: 0.875rem;
            background-color: $color-orange;

            @include respond-to(568plus) {
                width: 130px;
                font-size: 1rem;
            }
        }

        a {
            font-weight: bold;
            color: #2c3e50;
            text-decoration: none;
            margin: auto;
            padding: 0;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
}

</style>


